import * as actionTypes from './actionTypes';
import axios from 'lib/axios/axios';
import axiosGolang from 'lib/axios/axios-golang';
import {
  USERS,
  PAYMENT_SERVICE,
  PAYMENT_INQUIRY,
  PAYMENT_TRANSACTION,
  USERSV3
} from 'common/config';

import {
  loading,
  setApplicationStatus,
  setApplicationStatusV3
} from './loanApply';
import { setError } from './auth';
import {
  getChannelContextCode,
  getChannelContextMsg,
  getTommorowDate
} from 'helpers/Utility';
import { SendEventRepayment } from 'helpers/analytics';
import { generateHmac } from 'helpers/generateHmac';
import { LOAN_PAYMENT_STATUS_MAP } from 'common/constants';

export const loanPayment = (auth, body, param) => {
  return dispatch => {
    dispatch(loading(true));
    const url = USERS + PAYMENT_SERVICE;

    const { signature, timestamp } = generateHmac('POST', 'loanpayment', body);

    const header = {
      headers: {
        Authorization: auth.token,
        'Content-Type': 'application/json',
        'H-PNG-Signature': signature,
        'H-PNG-Timestamp': timestamp
        // 'Access-Control-Request-Headers': 'ChannelContext',
        // 'ChannelContext': JSON.stringify(context)
      }
    };

    const tommorow = getTommorowDate(new Date());

    axiosGolang
      .post(url, body, header)
      .then(res => {
        const status = res.status;
        if (status && status === 200) {
          dispatch(fetchMessage(res.data));
          const loanPaymentStatus = res.data?.loanPaymentStatus;

          if (loanPaymentStatus) {
            const mappedStatus = LOAN_PAYMENT_STATUS_MAP[loanPaymentStatus];

            if (mappedStatus) {
              dispatch(statusPayment(mappedStatus));
            }
          }
          SendEventRepayment({
            action: 'User Got Success Repayment',
            label: 'Repayment'
          });
          localStorage.setItem('freezeDateSuccess', tommorow);
          param && param.action();
          return;
        }
      })
      .catch(err => {
        const channelCode = getChannelContextCode(err, 'channel-context');
        const channelMessage = getChannelContextMsg(err, 'channel-context');

        if (!err.response) {
          dispatch(setError('connection'));
          return;
        }
        if (channelCode === null) {
          dispatch(setError('system'));
          return;
        }

        // Pending Payment
        if (
          channelCode === '211150' ||
          (channelCode === '211151' &&
            channelMessage.includes('Permintaan Paid Off Masih Diproses'))
        ) {
          dispatch(lastPayment(tommorow));
          dispatch(statusPayment('PENDING'));
          SendEventRepayment({
            action: 'User Got Pending Repayment',
            label: 'Repayment'
          });
          param && param.action();
          return;
        }

        const paymentStatusMap = {
          211151: {
            status: 'FAILURE',
            action: 'User Got Failure Repayment'
          },
          211152: {
            status: 'INSUFFICIENT',
            action: 'User Got Insufficient Balance On Saving'
          },
          11022: {
            status: 'ERROR_ACCOUNT',
            action: 'There is a problem with the account number'
          },
          11023: {
            status: 'ERROR_SACA',
            action: 'There is a problem with the SACA, data user'
          },
          11024: {
            status: 'ERROR_NIK',
            action: 'NIK does not match from inquiry saca and cif'
          },
          11025: {
            status: 'ERROR_CIF',
            action:
              'NIK does not match from inquiry cif pinang (clad) with nik rayanet'
          }
        };

        const paymentStatus = paymentStatusMap[channelCode];

        if (paymentStatus) {
          dispatch(statusPayment(paymentStatus.status));

          SendEventRepayment({
            action: paymentStatus.action,
            label: 'Repayment'
          });
          param && param.action();
          return;
        }
        dispatch(setError('connection'));
      })
      .finally(() => {
        dispatch(loading(false));
      });
  };
};

export const loanPaymentInquiry = (auth, param) => {
  return dispatch => {
    dispatch(loading(true));

    const url =
      USERS + '/custom/applications/' + auth.applicationId + PAYMENT_INQUIRY;

    const header = {
      headers: {
        Authorization: auth.token,
        'Content-Type': 'application/json'
      }
    };

    axiosGolang
      .get(url, header)
      .then(res => {
        dispatch(inquiryPayment(res.data.data, true));
        param && param.action();
      })
      .catch(err => {
        if (!err.response) {
          dispatch(setError('connection'));
          return;
        }
        if (getChannelContextCode(err, 'channel-context') === null) {
          dispatch(setError('system'));
          return;
        }

        // No Loan Schudeled
        if (getChannelContextCode(err, 'channel-context') === '8504') {
          dispatch(inquiryPayment('', false));
          param && param.action();
          return;
        }

        dispatch(setError('connection'));
      })
      .finally(() => dispatch(loading(false)));
  };
};

export const loanPaymentTrasaction = (auth, param) => {
  return dispatch => {
    dispatch(loading(true));

    const url =
      USERS +
      '/' +
      (localStorage.getItem('phonePrincipal') || auth.phoneNo) +
      '/custom/applications/' +
      auth.applicationId +
      PAYMENT_TRANSACTION;

    const header = {
      headers: {
        Authorization: auth.token,
        'Content-Type': 'application/json'
      }
    };

    const body = {
      loanAccount: String(param.loanAccount),
      totalPayAmount: String(param.totalPayAmount),
      // tranIdentifier: "PAYMENT" / "BRIVA"
      tranIdentifier: 'PAYMENT'
    };

    axios
      .post(url, body, header)
      .then(res => {
        dispatch(trasactionPayment(res.data.data));
      })
      .catch(err => {
        return err;
      })
      .finally(() => dispatch(loading(false)));
  };
};

export const loanPaymentSuplesi = (auth, body, param) => {
  return dispatch => {
    dispatch(loading(true));

    const url = USERS + '/custom/servicerequests/loan-payment-suplesi';

    const { signature, timestamp } = generateHmac('POST', 'loanpayment', body);

    const header = {
      headers: {
        Authorization: auth.token,
        'Content-Type': 'application/json',
        'H-PNG-Signature': signature,
        'H-PNG-Timestamp': timestamp
        // 'Access-Control-Request-Headers': 'ChannelContext',
        // 'ChannelContext': JSON.stringify(context)
      }
    };

    axiosGolang
      .put(url, body, header)
      .then(res => {
        if (res) dispatch(setApplicationStatusV3(res?.data?.applicationStatus));
        param?.success?.();
        return;
      })
      .catch(err => {
        dispatch(loading(false));

        if (!err.response) {
          dispatch(setError('connection'));
          return;
        }

        if (getChannelContextCode(err, 'channel-context') === null) {
          dispatch(setError('system'));
          return;
        }

        // STILL PROCESSING PAID OFF
        if (getChannelContextCode(err, 'channel-context') === '211150') {
          dispatch(setApplicationStatusV3('PAID_SUP_PROCESS'));
          dispatch(setApplicationStatus('PAID_SUP_PROCESS'));
          param?.onProcess?.();
          return;
        }

        // FAILURE
        if (
          getChannelContextCode(err, 'channel-context') === '211151' ||
          getChannelContextCode(err, 'channel-context') === '1205'
        ) {
          dispatch(statusPayment('FAILURE'));
          param?.error?.();
          return;
        }

        // INSUFFICIENT
        if (getChannelContextCode(err, 'channel-context') === '211152') {
          dispatch(statusPayment('INSUFFICIENT'));
          param?.error?.();
          return;
        }

        dispatch(setError('connection'));
      });
  };
};

export const inquiryLoanPayment = (auth, param) => {
  return (dispatch, getState) => {
    dispatch(loading(true));

    const appId = getState().loanApply.applicationIdV3;

    const url = `${USERSV3}/custom/inquiry-paid-off-suplesi/${appId}`;

    const header = {
      headers: {
        Authorization: auth.token,
        'Content-Type': 'application/json'
      }
    };

    axiosGolang
      .get(url, header)
      .then(res => {
        if (res) {
          dispatch(setInquiryLoanPayment(res.data?.data));
          param?.action?.();
          return;
        }
      })
      .catch(err => {
        if (err.toString().includes('Network Error')) {
          dispatch(setError('connection'));
        } else {
          dispatch(setError('system'));
        }
      })
      .finally(() => {
        dispatch(loading(false));
      });
  };
};

export const inquiryLoanPaymentStatus = (auth, body, param) => {
  return dispatch => {
    dispatch(loading(true));

    const url = `${USERS}/custom/servicerequests/loan-payment-status`;

    const { signature, timestamp } = generateHmac('PUT', 'inquiryloanpayment');

    const header = {
      headers: {
        Authorization: auth.token,
        'Content-Type': 'application/json',
        'H-PNG-Signature': signature,
        'H-PNG-Timestamp': timestamp
        // 'Access-Control-Request-Headers': 'ChannelContext',
        // 'ChannelContext': JSON.stringify(context)
      }
    };

    axiosGolang
      .put(url, body, header)
      .then(res => {
        dispatch(loading(false));
        if (res) {
          const applicationStatus = res.data?.paidOffDetails?.applicationStatus;
          const loanPaymentStatus = res.data?.paidOffDetails?.loanPaymentStatus;

          dispatch(setInquiryLoanPaymentStatus(res.data?.paidOffDetails));
          dispatch(setApplicationStatus(applicationStatus));
          dispatch(setApplicationStatusV3(applicationStatus));
          if (applicationStatus === 'PAID_SUP_PROCESS') {
            dispatch(loading(false));
            return;
          }
          if (applicationStatus === 'LOAN_PAID' && loanPaymentStatus) {
            const mappedStatus = LOAN_PAYMENT_STATUS_MAP[loanPaymentStatus];

            if (mappedStatus) {
              dispatch(statusPayment(mappedStatus));
            }
          }

          param?.action?.(applicationStatus, loanPaymentStatus);
          return;
        }
      })
      .catch(err => {
        dispatch(loading(false));

        if (err.toString().includes('Network Error')) {
          dispatch(setError('connection'));
          return;
        }

        // STILL PROCESSING PAID OFF
        if (getChannelContextCode(err, 'channel-context') === '211150') {
          param?.onProcess?.();
          return;
        }

        // INSUFFICIENT
        if (getChannelContextCode(err, 'channel-context') === '211152') {
          dispatch(statusPayment('INSUFFICIENT'));
          param?.action?.('PAID_SUP_FAILED');
          return;
        }

        // FAILURE
        if (
          getChannelContextCode(err, 'channel-context') === '211151' ||
          getChannelContextCode(err, 'channel-context') === '1005'
        ) {
          dispatch(statusPayment('FAILURE'));
          param?.action?.('PAID_SUP_FAILED');
          return;
        }

        dispatch(setError('system'));
      });
  };
};

export const inquiryPayment = (data, status) => {
  return {
    type: actionTypes.PAYMENT_INQUIRY,
    data: data,
    status: status
  };
};

export const trasactionPayment = data => {
  return {
    type: actionTypes.PAYMENT_TRANSACTION,
    data: data
  };
};

export const fetchMessage = data => {
  return {
    type: actionTypes.FECT_MESSAGE_PAYMENT,
    data: data
  };
};

export const statusPayment = value => {
  return {
    type: actionTypes.STATUS_PAYMENT,
    val: value
  };
};

export const lastPayment = value => {
  return {
    type: actionTypes.LAST_PAYMENT,
    val: value
  };
};

export const setInquiryLoanPayment = data => {
  return {
    type: actionTypes.SET_INQUIRY_LOAN_PAYMENT,
    res: data
  };
};

export const setInquiryLoanPaymentStatus = data => {
  return {
    type: actionTypes.SET_INQUIRY_LOAN_PAYMENT_STATUS,
    res: data
  };
};

export const setSubtractionPaidOffLifeTime = () => {
  return {
    type: actionTypes.SUBTRACTION_PAID_OFF_LIFE_TIME
  };
};
